import { render, staticRenderFns } from "./box2.vue?vue&type=template&id=10fe8108&scoped=true&"
import script from "./box2.vue?vue&type=script&lang=js&"
export * from "./box2.vue?vue&type=script&lang=js&"
import style0 from "./box2.vue?vue&type=style&index=0&id=10fe8108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe8108",
  null
  
)

export default component.exports